export const filter_properties = (filters, data) => {
  let findPOA = filters.find((element) => element.field === 'includePOA');
  let poaValue = findPOA ? findPOA.values[0] : true;
  let reducedFilters = filters.filter(f => ['size_ft_max', 'size_m_max', 'rent_pa', 'availability'].includes(f.field) && f.values)
  if(reducedFilters.length > 0) {
    const reduceProperties = data.available_properties.filter(
      p => {
        let returnProperty = true
        reducedFilters.forEach(element => {
          if(returnProperty && element.field === 'rent_pa') {
            let returnPropertyLoop = false;
            let elementValue = element.values[0]
            if ( p[element.field] === null && poaValue) {
              returnPropertyLoop = true;
            } else if (p[element.field] !== null && (!elementValue.from || elementValue.from <= p[element.field]) &&  (!elementValue.to || elementValue.to >= p[element.field])) {
              returnPropertyLoop = true;
            }
            returnProperty = returnPropertyLoop
           } else if(returnProperty && element.field !== 'availability') {
            let elementValue = element.values[0]
            returnProperty = p[element.field] !== null && (!elementValue.from || elementValue.from <= p[element.field]) &&  (!elementValue.to || elementValue.to >= p[element.field]);
          } else if(returnProperty && element.field === 'availability') {
            let returnPropertyLoop = false;
            (element?.values || [ p.availability]).forEach(element => {
              returnPropertyLoop = !returnPropertyLoop ? p['availability'].includes(element) : true
            })
            returnProperty = returnPropertyLoop
          }
        })
        return returnProperty
      }
    )
    data.available_properties = reduceProperties;
  }

}
